"use strict";

const activateContent = function (tab, tabs, products) {
    tabs.forEach((el) => el.classList.remove("active-tab"));
    tab.classList.add("active-tab");
    
	products.forEach((el) => el.classList.remove("active-tab"));

	products.forEach((el) => {
		if (el.id === tab.id) {
			el.classList.add("active-tab");
		}
	});
};

const toggleProducts = function () {
    const relatedProductsSection = document.querySelectorAll(".dm-general-tabs");

    relatedProductsSection.forEach(section => {
        // Only select direct children tabs and items, not nested ones
        const tabsWrap = section.querySelector(":scope > .dm-general-tabs-top > .dm-general-tabs-tabs-wrap > .dm-general-tabs-tabs");
        const tabs = tabsWrap ? Array.from(tabsWrap.querySelectorAll(":scope > .dm-general-tabs-tab-switch")) : [];
        const products = Array.from(section.querySelectorAll(":scope > .dm-general-tabs-item"));

        if (tabs.length > 0 && products.length > 0) {
            const firstTab = tabs[0];
            const firstProduct = products[0];

            firstTab.classList.add("active-tab");
            firstProduct.classList.add("active-tab");

            tabs.forEach((tab) => {
                tab.addEventListener("click", (event) => {
                    // Prevent event from bubbling to parent general-tabs
                    event.stopPropagation();
                    activateContent(tab, tabs, products);
                });
            });
        }
    });
};

toggleProducts();

const initializeCarousel = () => {
    const relatedProductsSections = document.querySelectorAll(".dm-general-tabs");

    relatedProductsSections.forEach((section) => {
        // Only select direct children, not nested ones
        const tabsWrap = section.querySelector(":scope > .dm-general-tabs-top > .dm-general-tabs-tabs-wrap");
        const carouselElement = tabsWrap ? tabsWrap.querySelector(":scope > .dm-general-tabs-tabs") : null;

        const tabs = carouselElement ? Array.from(carouselElement.querySelectorAll(":scope > .dm-general-tabs-tab-switch")) : [];
        const products = Array.from(section.querySelectorAll(":scope > .dm-general-tabs-item"));

        if (carouselElement && tabs.length > 0) {
            const carousel = jQuery(carouselElement).owlCarousel({
                loop: false,
                nav: false,
                dots: false,
                items: 1,
                margin: 20,
            });

            const nextButton = tabsWrap.querySelector(":scope > .dm-general-tabs-tabs-controls > #next.dm-general-tabs-tabs-control-single");
            const prevButton = tabsWrap.querySelector(":scope > .dm-general-tabs-tabs-controls > #prev.dm-general-tabs-tabs-control-single");

            if (nextButton) {
                jQuery(nextButton).click(() => {
                    carousel.trigger("next.owl.carousel");
                });
            }

            if (prevButton) {
                jQuery(prevButton).click(() => {
                    carousel.trigger("prev.owl.carousel");
                });
            }

            carousel.on("translated.owl.carousel", function () {
                const activeElement = carouselElement.querySelector(
                    ":scope > .owl-item.active .dm-general-tabs-tab-switch"
                );

                if (activeElement) {
                    activateContent(activeElement, tabs, products);
                }
            });
        }
    });
};


if (window.innerWidth < 769) {
    (function ($) {
        $(document).ready(function () {
            initializeCarousel();
        });
    })(jQuery);
}
